import React from 'react';
import { Outlet } from 'react-router-dom';
import './Alert.css';

/**
 * Shell component for the Alert module so nested routes can render inside a
 * consistent container.
 */
export default function Alert() {
    return (
        <div className="alert-shell">
            <Outlet />
        </div>
    );
}
